import { TextButton, TextButtonLink } from '@creditornot/cb-button';
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import FileSelector from './FileSelector';
import ImageWrapper from './ImageWrapper';

type Props = {
  className?: string;
  imageUrl: string;
  downloadUrl?: string;
  onRemove: () => void;
  onSelectFile: (file: File) => void;
};

const Image = styled.img`
  display: block;
  width: 100%;
`;

const Actions = styled.div`
  display: flex;
  margin-block-start: 16px;
  & > * + * {
    margin-inline-start: 16px;
  }
`;

const ExistingImage = ({ className, imageUrl, downloadUrl, onRemove, onSelectFile }: Props) => {
  const [isSelectingFile, setIsSelectingFile] = useState(false);
  return (
    <div className={className}>
      {isSelectingFile ? (
        <FileSelector
          background={<Image src={imageUrl} />}
          onCancel={() => {
            setIsSelectingFile(false);
          }}
          onSelectFile={onSelectFile}
        />
      ) : (
        <>
          <ImageWrapper>
            <Image src={imageUrl} />
          </ImageWrapper>
          <Actions>
            {downloadUrl && (
              <TextButtonLink href={downloadUrl} target="_blank">
                <FormattedMessage id="image-upload.download" />
              </TextButtonLink>
            )}
            <TextButton
              onClick={() => {
                setIsSelectingFile(true);
              }}
            >
              <FormattedMessage id="image-upload.change-image" />
            </TextButton>
            <TextButton variant="negative" onClick={onRemove}>
              <FormattedMessage id="image-upload.remove" />
            </TextButton>
          </Actions>
        </>
      )}
    </div>
  );
};

export default ExistingImage;
